import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "$isHiddenFor", "responsive", "use"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
import { useUserOwnsPlaylist } from '../savedItemsQueries';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { EditPlaylistModalTrigger } from './EditPlaylistModalTrigger';
import { jsx as _jsx } from "react/jsx-runtime";
export const EditPlaylistButton = _ref => {
  let {
      playlistId,
      $isHiddenFor,
      responsive,
      use = 'link'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownedByUser = useUserOwnsPlaylist(playlistId);
  const {
    matches
  } = useMediaQuery($isHiddenFor);
  if (!ownedByUser || matches) return null;
  return /*#__PURE__*/_jsx(EditPlaylistModalTrigger, {
    playlistId: playlistId
    // allows us to keep the context menu open when the button is clicked
    ,
    renderTrigger: ({
      openModal
    }) => {
      const onEditPlaylistClick = () => {
        UsageTracker.track('playlistInteraction', {
          action: 'edit-details-click',
          playlistId
        });
        openModal();
      };
      return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
        onClick: onEditPlaylistClick,
        responsive: responsive,
        use: use,
        children: /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          textAlign: "start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.editDetails"
          })
        })
      }));
    }
  });
};